import { FC } from "react";
import { Box, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { makeSxStyles } from "ui";

export interface MoreResultsLinkProps {
  /** Number of matches on the OTHER entity for the current search term. */
  count: number;
  /** Display name of the other entity's section, e.g. "Customers"/"Leads". */
  entityCategoryLabel: string;
  /** Route of the other entity's list page, e.g. AdRoutes.leads. */
  targetRoute: string;
  searchTerm: string;
}

/**
 * "Check X more results under Customers/Leads." prompt shown below the
 * Customers/Leads tables (ESR-1597). Renders nothing when there's nothing to
 * point to - callers can render it unconditionally.
 */
const MoreResultsLink: FC<MoreResultsLinkProps> = ({
  count,
  entityCategoryLabel,
  targetRoute,
  searchTerm,
}) => {
  const navigate = useNavigate();
  const styles = useStyles();

  if (count <= 0) {
    return null;
  }

  const resultLabel = count === 1 ? "result" : "results";

  return (
    <Box sx={styles.container}>
      <Link
        component="button"
        type="button"
        variant="body2"
        underline="hover"
        onClick={() =>
          navigate(`${targetRoute}?search=${encodeURIComponent(searchTerm)}`)
        }
        sx={styles.link}
      >
        Check {count} more {resultLabel} under {entityCategoryLabel}.
      </Link>
    </Box>
  );
};

const useStyles = makeSxStyles(() => ({
  container: {
    mt: "12px",
  },
  link: {
    verticalAlign: "baseline",
  },
}));

export default MoreResultsLink;
